import { addonQuotePriceEnhanced, addonQuoteSponsoFee } from 'state/addonForm/addonForm.action';
import { commonTradeAction } from 'state/forms/actions/trade';
import type { SponsoFee, SponsoFeeField } from 'state/quotes/sponsoFees/sponsoFees';
import type { PriceEnhancement, PriceEnhancementField } from 'state/quotes/trades/trades.model';
import type { Thunk } from 'state/state.common';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export function quotePriceEnhancedThunk(
  tabId: string,
  workspace: QuoteWorkspaceType,
  key: PriceEnhancementField,
  value: PriceEnhancement[PriceEnhancementField],
): Thunk<void> {
  return (dispatch, getState, { selectors: { getFormQuoteId } }) => {
    const state = getState();
    const quoteId = getFormQuoteId(state, workspace, tabId)!;
    switch (workspace) {
      case 'static':
      case 'dynamic':
        dispatch(commonTradeAction.quotePriceEnhanced(workspace, quoteId, key, value));
        return;
      case 'postTrade':
        dispatch(addonQuotePriceEnhanced(quoteId, key, value));
        return;
      default:
        throw new Error('Price enhancer is not supported for workspace ' + workspace);
    }
  };
}
export function quoteSponsoFeeThunk(
  tabId: string,
  workspace: QuoteWorkspaceType,
  key: SponsoFeeField,
  value: SponsoFee[SponsoFeeField],
): Thunk<void> {
  return (dispatch, getState, { selectors: { getFormQuoteId } }) => {
    const state = getState();
    const quoteId = getFormQuoteId(state, workspace, tabId)!;
    switch (workspace) {
      case 'static':
      case 'dynamic':
        dispatch(commonTradeAction.quoteSponsoFee(workspace, quoteId, key, value));
        return;
      case 'postTrade':
        dispatch(addonQuoteSponsoFee(quoteId, key, value));
        return;
      default:
        throw new Error('Price enhancer is not supported for workspace ' + workspace);
    }
  };
}
